import { MODAL_WIDTH } from "globalStylesVariables";
import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  modal: {
    padding: "var(--spacing-x3, 12px) var(--spacing-x3, 12px) var(--spacing-x5, 20px) var(--spacing-x8, 32px)",
  },
  content: {
    paddingBottom: "var(--spacing-x13, 52px)",
    width: `${MODAL_WIDTH}px`,
  },
});
